import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import InsuranceDiscountsAnalytics from '@/components/insurance-sub/InsuranceDiscountsAnalytics';
import InsuranceDiscountsRecords from '@/components/insurance-sub/InsuranceDiscountsRecords';
import { Percent } from 'lucide-react';

export default function InsuranceDiscounts() {
    return (
        <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
            <div className="mb-8">
                <div className="flex items-center gap-3 mb-2">
                    <Percent className="h-8 w-8" />
                    <h1 className="text-4xl font-semibold tracking-tight">Insurance Discounts</h1>
                </div>
                <p className="text-muted-foreground">Insurance discount records.</p>
            </div>

            <Tabs defaultValue="analytics" className="space-y-6">
                <TabsList>
                    <TabsTrigger value="analytics">Analytics</TabsTrigger>
                    <TabsTrigger value="records">Records</TabsTrigger>
                </TabsList>

                <TabsContent value="analytics">
                    <InsuranceDiscountsAnalytics />
                </TabsContent>

                <TabsContent value="records">
                    <InsuranceDiscountsRecords />
                </TabsContent>
            </Tabs>
        </div>
    );
}
